module.exports = __webpack_public_path__ + "img/digital pr.df567612.jpeg";